import { Icon } from '../..'
import type { TIconDualColorsProps } from '../../types'
import * as Comp from './dual-color.styles'

export const IconDualColor = (props: TIconDualColorsProps) => {
  const { symbols, colors, size, testID } = props
  return (
    <Comp.Group testID={testID}>
      <Icon symbol={symbols[0]} color={colors[0]} size={size} />
      <Comp.Container>
        <Icon symbol={symbols[1]} color={colors[1]} size={size} />
      </Comp.Container>
    </Comp.Group>
  )
}
